<div
  class="v3-loading-screen"
  role="status"
  aria-live="polite"
  aria-label="KI-Analyse wird geladen"
>
  <ng-lottie [options]="options" class="lottie" aria-hidden="true"></ng-lottie>
  <p class="label">{{ label }}</p>
</div>
